import type { AddressApiItem, AddressFormValues } from '../../models';

export const mapAddAddressPayload = (
  values: AddressFormValues,
  customerKey: number,
  customerName: string,
): AddressApiItem => ({
  address1: values.address1,
  address2: values.address2,
  categoryKey: 0,
  categoryName: '',
  city: values.city,
  country: values.country.label,
  countryCode: values.country.id,
  customerKey,
  customerName,
  id: 0,
  name: values.name ?? '',
  postalCode: values.postalCode,
  state: values.state.label,
  stateCode: values.state.id,
});

export const mapUpdateAddressPayload = (
  addressId: string,
  values: AddressFormValues,
  customerKey: number,
  customerName: string,
): AddressApiItem => ({
  address1: values.address1,
  address2: values.address2,
  categoryKey: 0,
  categoryName: '',
  city: values.city,
  country: values.country.label,
  countryCode: values.country.id,
  customerKey,
  customerName,
  id: Number(addressId),
  name: values.name ?? '',
  postalCode: values.postalCode,
  state: values.state.label,
  stateCode: values.state.id,
});
